<template>
    <v-container flex-column fill-height justify-center no-wrap>
      <notification-message class="notificationMessage" />
      <SignIn />
    </v-container>
</template>

<script>
// @ is an alias to /src
import SignIn from "@/components/components-base/login/SignIn";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";

export default {
  name: "LogIn",
  created() {},
  components: {
    NotificationMessage,
    SignIn,
  },
};
</script>